import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import UserAccount from "./UserAccount";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ContentCreatorSettingData from "./ContentCreatorSettingData/ContentCreatorSettingData";
import { useLocation } from "react-router-dom";
import { useAuth } from "context/authContext";

const SettingData = () => {
  const { currentUser } = useAuth();
  const [open, setOpen] = React.useState(false);
  const [profileImage, setProfileImage] = useState("/mnt/data/image.png");
  const location = useLocation();
  const handleClick = () => {
    setOpen(!open);
  };

  const handleEditImageClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const queryParams = new URLSearchParams(location.search);
  const user = queryParams.get("user");

  return (
    <>
      <Grid
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={{ xs: 2, md: 5 }}
        px={{ xs: 2, md: 5 }}
      >
        <Box
          display="flex"
          px={{ xs: 0, md: 5 }}
          justifyContent="space-between"
          flexDirection={{ xs: "column", md: "row" }}
          gap={{ xs: 2, md: 5 }}
        >
          <Box
            fontWeight={700}
            pt={{ xs: 15, md: 8 }}
            fontSize="35px"
            color="#233F91"
            display="flex"
            alignItems="center"
          >
            Settings
          </Box>
          <Typography
            display={"flex"}
            pt={{ xs: 0, md: 8 }}
            flexDirection={"column"}
            alignItems={{ xs: "flex-start", md: "flex-end" }}
            mt={1}
          >
            <Button sx={styleSheet.textButton}>Privacy Policy</Button>
            <Button sx={styleSheet.textButton}>Terms of Service</Button>
          </Typography>
        </Box>
        <Typography
          sx={{
            border: { xs: "1px solid #E9E9EA", md: "none" },
            width: { xs: "100%", md: "0" },
          }}
        ></Typography>
        {currentUser?.userInfo?.type === "content-creator" &&
          currentUser?.userInfo?.accountStatus === "approve" ?
          (
            <ContentCreatorSettingData />
          ) : (
            <UserAccount />
          )}
      </Grid>
    </>
  );
};

export default SettingData;

const styleSheet = {
  dowIcon: {
    position: "absolute",
    bottom: 0,
    right: 2,
    width: "20.12px",
    height: "20.12px",
  },
  box: {
    position: "absolute",
    top: "180px",
    zIndex: 1,
    right: { xs: "93px", md: "122px" },
    width: { xs: 172, md: 115 },
    bgcolor: "background.paper",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "8px",
    border: "0.5px solid #EDEDED",
    p: 2,
  },
  textButton: {
    color: "#000000",
    fontWeight: 400,
    fontSize: "17px",
  },
};
